// extracted by mini-css-extract-plugin
export default {"modalContainer":"lsx1DyPsBUIHdCS9Eegn","title":"K8M0ZblizeVbgwMcWtIX","subtitle":"JpdC3UKO2HoOeAKYP4Fw","buttonWrapper":"JBlvXnXEmphloJovCzwQ"};